import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { BadgeComponent } from '../../badge/badge.component';
import { IconComponent } from '../../icons/icon/icon.component';
import { Icon } from '../../icons/icon/svg-cache.service';

@Component({
  standalone: true,
  selector: 'ui-subnav-item',
  templateUrl: './subnav-item.component.html',
  styleUrl: './subnav-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, BadgeComponent, RouterLink, RouterLinkActive],
})
export class SubnavItemComponent {
  readonly icon = input<Icon>();
  readonly value = input.required<string>();
  readonly isNew = input<boolean>(false);
  readonly badgeText = input<string | null>(null);
  readonly variant = input<'parent' | 'child' | 'child-of-child'>('parent');
  readonly link = input<string>();
}
